import { createContext } from 'react';

const ModuleContext = createContext();

export default ModuleContext;